import { ETK_CESAR } from "@constants";
import PropTypes from "prop-types";
import { EffectCoverflow } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSnapshot } from "valtio";

import React from "react";
import { useSelector } from "react-redux";

import { getFilenameFromUrl } from "@helpers/general";

import { getProductTitle } from "@components/OrderTaking/Helpers";
import { imageWithFallback } from "@components/OrderTaking/Helpers/Commonfunction";
import { getPrice } from "@components/OrderTaking/Helpers/getPrice";

import { kioskStore } from "@pages/Kiosk/store";

import "./index.css";

import "swiper/swiper-bundle.min.css";

export function ProductSizeSwiper({
    productProperties,
    selectedSizeIndex,
    setSelectedSizeIndex,
    visiblePrice,
    listOptions,
    productPrice,
    productImage,
}) {
    let optionPrice = 0;
    if (visiblePrice) {
        const { price } = getPrice(listOptions, productPrice, false);
        optionPrice = price;
    }
    const { devise } = useSnapshot(kioskStore);
    const { cardType } = useSelector((state) => state.orderSlice);
    return (
        <Swiper
            className="product-size-swiper-container m-2"
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            slidesPerView="auto"
            loop={true}
            coverflowEffect={{
                rotate: 0,
                stretch: -40,
                depth: 225,
                modifier: 1,
                slideShadows: false,
            }}
            slideToClickedSlide={true}
            onActiveIndexChange={(swiper) =>
                setSelectedSizeIndex(swiper.realIndex)
            }
            spaceBetween={12}
            modules={[EffectCoverflow]}
        >
            {productProperties.map((item, index) => {
                const itemImage =
                    cardType === ETK_CESAR
                        ? productImage
                        : getFilenameFromUrl(item.image, "catalog", "Items");
                const optionTitle = getProductTitle(item.name);
                return (
                    <SwiperSlide
                        key={item.id}
                        className="product-size-swiper-slide-img product-size-swiper-slide"
                        onClick={() => {
                            setSelectedSizeIndex(index);
                        }}
                        style={{
                            opacity: index !== selectedSizeIndex ? "0.5" : "1",
                        }}
                    >
                        <div
                            className="d-flex flex-column justify-content-center align-items-center"
                            style={{ gap: "15px" }}
                        >
                            <div
                                className="swiper-slide-product-name"
                                style={{
                                    marginTop:
                                        index !== selectedSizeIndex
                                            ? "56px"
                                            : "unset",
                                }}
                            >
                                {optionTitle}
                            </div>
                            {index === selectedSizeIndex && visiblePrice ? (
                                <div className="swiper-slide-product-price">
                                    <span className="price-text">
                                        {optionPrice - productPrice.content >= 0
                                            ? "+"
                                            : null}
                                        {(
                                            optionPrice - productPrice.content
                                        ).toFixed(devise.decimalPrice) +
                                            ` ${devise.deviseSymbole}`}
                                    </span>
                                </div>
                            ) : null}
                            <div
                                className="swiper-slide-product-img"
                                style={{
                                    border:
                                        index === selectedSizeIndex
                                            ? "3px solid var(--global-color)"
                                            : "unset",
                                }}
                            >
                                <img
                                    onError={imageWithFallback}
                                    src={itemImage}
                                    style={{ borderRadius: "35px" }}
                                />
                            </div>
                        </div>
                    </SwiperSlide>
                );
            })}
        </Swiper>
    );
}

ProductSizeSwiper.propTypes = {
    productProperties: PropTypes.arrayOf(PropTypes.object).isRequired,
    selectedSizeIndex: PropTypes.number,
    setSelectedSizeIndex: PropTypes.func,
    visiblePrice: PropTypes.bool,
    listOptions: PropTypes.array,
    productPrice: PropTypes.object,
    productImage: PropTypes.string,
};
